import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'rating',
  templateUrl: 'rating.html',
  styleUrls: ['rating.scss'],
})
export class RatingComponent {

  @Input() public value: number;
  @Input() public max: number = 5;
  @Input() public interactive: boolean = false;
  @Input() public large: boolean = false;

  @Output() public valueChange: EventEmitter<number> = new EventEmitter<number>();

  public createRating(): Array<boolean> {
    const rating: Array<boolean> = [];

    for (let i: number = 0; i < this.max; i++) {
      rating.push(i < this.value);
    }
    return rating;
  }

  public onStarSelected(event: Event, index: number): void {
    event.preventDefault();
    event.stopImmediatePropagation();
    
    if (!this.interactive) {
      return;
    }

    this.value = index + 1;
    this.valueChange.emit(this.value);
  }
}
